(() => {
  const mobile = window.matchMedia('(max-width: 899px)');

  // Barra de compra fija.
  // Móvil: visible desde el principio salvo cuando ya hay un botón de compra en pantalla.
  // Escritorio: aparece al pasar el hero / la caja de compra.
  const bar = document.querySelector('[data-cta-sticky]');
  if (bar && 'IntersectionObserver' in window) {
    const hero = document.querySelector('.cta-hero, .cta-mp__buy');
    const hideOn = document.querySelectorAll('.cta-mp__buy, .cta-hero__buy, .cta-vs, .cta-offer, .cta-final, .footer');
    let pastHero = !hero;
    const seen = new Set();
    const update = () => {
      const show = (mobile.matches || pastHero) && seen.size === 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('cta-has-sticky', show);
    };
    if (hero) {
      new IntersectionObserver(([e]) => {
        pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      }).observe(hero);
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
      update();
    });
    hideOn.forEach((el) => io.observe(el));
    mobile.addEventListener ? mobile.addEventListener('change', update) : mobile.addListener(update);
    update();
  } else if (bar) {
    bar.classList.add('is-visible');
  }

  // Animación de entrada suave
  const items = document.querySelectorAll('.cta-reveal');
  if ('IntersectionObserver' in window && items.length) {
    const ro = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((el) => ro.observe(el));
  } else {
    items.forEach((el) => el.classList.add('is-in'));
  }

  // Galería de producto: diapositivas de imagen y vídeo
  document.querySelectorAll('[data-cta-gallery]').forEach((g) => {
    const slides = g.querySelectorAll('.cta-mp__slide');
    const thumbs = g.querySelectorAll('.cta-mp__thumb');
    const go = (i) => {
      slides.forEach((s, n) => {
        const on = n === i;
        s.classList.toggle('is-active', on);
        s.querySelectorAll('video').forEach((v) => { if (!on) v.pause(); });
        s.querySelectorAll('iframe').forEach((f) => {
          if (!on && f.contentWindow) {
            f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            f.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        });
        if (on) s.querySelectorAll('video').forEach((v) => { if (v.autoplay || v.muted) v.play().catch(() => {}); });
      });
      thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.go) === i));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.go))));

    // Deslizar con el dedo en la imagen grande
    const stage = g.querySelector('.cta-mp__stage');
    let x0 = null;
    stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40 || slides.length < 2) return;
      const cur = [...slides].findIndex((s) => s.classList.contains('is-active'));
      go((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
    }, { passive: true });
  });

  // Selector de opción (Pack / Solo ebook): actualiza botones, precios y bloques solo-pack
  document.querySelectorAll('[data-cta-variants]').forEach((box) => {
    const apply = (input) => {
      const id = input.value;
      document.querySelectorAll('[data-cta-buy][data-variant]').forEach((a) => {
        const old = a.dataset.variant;
        if (old && old !== id) {
          a.href = a.href.replace(old, id);
          a.dataset.variant = id;
        }
      });
      document.querySelectorAll('[data-cta-price-now]').forEach((el) => { el.textContent = input.dataset.price; });
      const isFirst = input.dataset.first === '1';
      document.querySelectorAll('[data-cta-pack-only]').forEach((el) => { el.hidden = !isFirst; });
      document.querySelectorAll('.cta-price__was, .cta-price__save, .cta-mp__badge').forEach((el) => { el.hidden = !isFirst; });
      document.querySelectorAll('[data-cta-variant-name]').forEach((el) => {
        el.textContent = isFirst ? el.dataset.default : input.dataset.title;
      });
    };
    box.querySelectorAll('input[type="radio"]').forEach((r) => r.addEventListener('change', () => apply(r)));
    const checked = box.querySelector('input:checked');
    if (checked) apply(checked);
  });

  // Test "¿Cuál es tu punto de partida?"
  document.querySelectorAll('[data-cta-quiz]').forEach((quiz) => {
    const qs = [...quiz.querySelectorAll('[data-quiz-q]')];
    const results = quiz.querySelectorAll('[data-quiz-result]');
    const stepEl = quiz.querySelector('[data-quiz-step]');
    const bar = quiz.querySelector('[data-quiz-bar]');
    const order = ['P', 'A', 'R', 'T'];
    let score = {};
    let i = 0;
    const show = () => {
      qs.forEach((q, n) => { q.hidden = n !== i; });
      results.forEach((r) => { r.hidden = true; });
      if (stepEl) stepEl.textContent = `Pregunta ${i + 1} de ${qs.length}`;
      if (bar) bar.style.width = `${(i / qs.length) * 100}%`;
    };
    const finish = () => {
      const best = order.reduce((a, b) => ((score[b] || 0) > (score[a] || 0) ? b : a), order[0]);
      qs.forEach((q) => { q.hidden = true; });
      results.forEach((r) => { r.hidden = r.dataset.quizResult !== best; });
      if (stepEl) stepEl.textContent = '¡Listo!';
      if (bar) bar.style.width = '100%';
      const shown = quiz.querySelector(`[data-quiz-result="${best}"]`);
      if (shown) { shown.setAttribute('tabindex', '-1'); shown.focus({ preventScroll: true }); }
    };
    quiz.querySelectorAll('.cta-quiz__a').forEach((btn) => {
      btn.addEventListener('click', () => {
        const pr = btn.dataset.profile;
        if (pr) score[pr] = (score[pr] || 0) + 1;
        i += 1;
        if (i >= qs.length) finish(); else show();
      });
    });
    quiz.querySelectorAll('[data-quiz-reset]').forEach((b) => b.addEventListener('click', () => { score = {}; i = 0; show(); }));
  });

  // Consentimiento de descarga: hay que marcarlo antes de ir al pago
  const modal = document.querySelector('[data-cta-consent-modal]');
  if (modal) {
    const boxes = () => document.querySelectorAll('[data-cta-consent]');
    const go = modal.querySelector('[data-cta-consent-go]');
    let consented = false;
    let pendingHref = null;
    let lastFocus = null;
    const sync = (val) => {
      consented = val;
      boxes().forEach((b) => { b.checked = val; });
      go.setAttribute('aria-disabled', String(!val));
    };
    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('cta-noscroll');
      if (lastFocus) lastFocus.focus();
    };
    document.addEventListener('change', (e) => {
      if (e.target.matches && e.target.matches('[data-cta-consent]')) sync(e.target.checked);
    });
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('[data-cta-buy]');
      if (!a || consented) return;
      e.preventDefault();
      pendingHref = a.href;
      lastFocus = a;
      modal.hidden = false;
      document.documentElement.classList.add('cta-noscroll');
      const cb = modal.querySelector('[data-cta-consent]');
      if (cb) cb.focus();
    }, true);
    go.addEventListener('click', (e) => {
      e.preventDefault();
      if (!consented) {
        const lbl = modal.querySelector('.cta-consent');
        if (lbl) { lbl.classList.remove('is-shake'); void lbl.offsetWidth; lbl.classList.add('is-shake'); }
        return;
      }
      if (pendingHref) window.location.href = pendingHref;
    });
    modal.querySelectorAll('[data-cta-consent-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  // Navegador interno de TikTok / Instagram / Facebook: mostrar aviso y botón para copiar el enlace
  if (/musical_ly|bytedance|tiktok|instagram|fban|fbav/i.test(navigator.userAgent)) {
    document.querySelectorAll('[data-cta-inapp]').forEach((el) => { el.hidden = false; });
  }
  document.querySelectorAll('[data-cta-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = window.location.href;
      let ok = false;
      try { await navigator.clipboard.writeText(url); ok = true; } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { ok = document.execCommand('copy'); } catch (e2) { ok = false; }
        ta.remove();
      }
      btn.textContent = ok ? '¡Copiado! Pégalo en Safari o Chrome' : url;
    });
  });

  // Cuenta atrás de la oferta (se oculta sola al terminar)
  document.querySelectorAll('[data-cta-countdown]').forEach((el) => {
    const end = new Date(el.dataset.ctaCountdown).getTime();
    if (Number.isNaN(end)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      const s = Math.floor(left / 1000);
      parts.d.textContent = pad(Math.floor(s / 86400));
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      parts.s.textContent = pad(s % 60);
    };
    const timer = setInterval(tick, 1000);
    tick();
  });
})();
